export const SET_DEFAULT_CHART = 'ADMIN_LAYOUT/SET_DEFAULT_CHART';
export const SET_DEFAULT_CHART_SUCCESS = 'ADMIN_LAYOUT/SET_DEFAULT_CHART_SUCCESS';
export const SET_DEFAULT_CHART_ERROR = 'ADMIN_LAYOUT/SET_DEFAULT_CHART_ERROR';
export const SET_SHOW_SIDEBAR_MENU = 'ADMIN_LAYOUT/SET_SHOW_SIDEBAR_MENU';
export const SET_DATA_TYPE = 'ADMIN_LAYOUT/SET_DATA_TYPE';